
import UIView from './ui_view';
import UIViewMobile from 'ui_mobile_view';
import BarrelView from './barrel_view';
import SlotView from './slot_view';
import FreegamesView from './freegames_view';
import RiskView from './risk_view';
import BonusView from "./bonus_view";
import SuperBonusView from "./superbonus_view";
import SETTINGS from "settings"
import imperative from 'imperative'
import whole_line from 'whole_line'

export default function (
    root,
    construct,
    {
        uiConfig,
        spec,
    },
    parent,
    uiContainer,
    always_interactive_container,
)
{
    if ( ! SETTINGS.isMobile ) console.log( "Server spec:", spec );
    const $ticker = parent.s( "ticker" );

    imperative( construct, spec, parent )

    whole_line( parent, construct.slotScene.view, spec )
    
    const barrel = BarrelView(
        construct.barrel,
        parent,
        $ticker,
        construct.freeGamesBarrel
    );
    
    const slot = SlotView(
        construct.slotScene.view,
        barrel.barrel,
        parent,
        $ticker,
    );
    
    const freegames = FreegamesView(
        construct.slotScene.view,
        parent,
        $ticker,
    );
    

    const risk = RiskView(
        construct.doubleGameScene && construct.doubleGameScene.view || undefined,
        parent,
        $ticker,
    );
    
    const bonus = BonusView(
        construct.slotScene.view,
        construct.bonusScene && construct.bonusScene.view || undefined,
        parent,
        $ticker
    );
    
    const superbonus = SuperBonusView(
        construct.slotScene.view,
        construct.bonusScene && construct.bonusScene.view || undefined,
        construct.superBonusScene && construct.superBonusScene.view || undefined,
        parent,
        $ticker
    );

    
    let scenes = [];
    for ( const i in construct ) {
        const item = construct[i];
        if (item && item.hasOwnProperty('view') && item.hasOwnProperty('z')) {
            scenes.push(item);
        }
    }
    
    // сортируем в порядке возрастания Z
    scenes.sort((a, b) => a.z - b.z);
    
    // добавляем в root
    for (const item of scenes) {
        if ( ! item.view ) continue
        root.addChild(item.view);
    }

    //переместим help сцену выше других сцен (так проще, чем менять z индекс в каждой игре с бонусом)
    if ( construct.helpScene ) root.addChild( construct.helpScene.view )
    
    scenes = null;

    const upperScenesContainer = new PIXI.Container;

    const currentUIView = (SETTINGS.isMobile && !SETTINGS.SINGLE_INTERFACE) ? UIViewMobile : UIView;
    const ui = currentUIView({
        parent,
        uiConfig,
        always_interactive_container,
        spec,
        uiContainer,
        upperScenesContainer
    });
    // должен всегда добавляться последним
    root.addChild( ui.ui );
    
    const index = root.getChildIndex( construct.slotScene.view )
    
    const roulette = new PIXI.Container
    roulette.scale.set( SETTINGS.screen.resolution.width / 1366, SETTINGS.screen.resolution.height / 768);
    root.addChildAt( roulette, index + 1 );
    
    const jackpot = new PIXI.Container
    root.addChildAt(jackpot, index+2);
    
    const progressive_jackpot = new PIXI.Container
    root.addChild( progressive_jackpot );

    root.addChild( upperScenesContainer );
    
    return {
        ui,
        barrel,
        slot,
        risk,
        help : (construct.helpScene ? construct.helpScene.view : undefined),
        bonus,
        superbonus,
        roulette,
        jackpot,
        progressive_jackpot,
        freegames,
    };
}




// WEBPACK FOOTER //
// ./src/library/run.es6